<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [showProjectName]="context == 'candidate'">
    <i scActivityIcon class="fa-sharp fa-solid fa-comment"></i>
    @if (context != 'project') {
    {{ texts.referenceReviewShort[language] }}
    } @else {
    {{ texts.referenceReviewPrefix[language] }} <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> {{ texts.referenceReviewSuffix[language] }}
    }
    <div scActivityBody>
        @if (activity.Payload?.ReviewItems?.length) {
        <ul class="tag-list review-tags list-inline mb-2">
            @for (item of activity.Payload.ReviewItems; track $index) {
            <li class="list-inline-item">
                <span class="tag tag-clip-text tag-light oneline">
                    @if (texts.referenceReviewItemPrefixes[item.type]) {
                    <span class="text-muted me-1">{{ texts.referenceReviewItemPrefixes[item.type][language] }}</span>
                    }
                    {{ item.label }}
                </span>
            </li>
            }
        </ul>
        }
        <p [innerHTML]="activity.Payload?.Body"></p>
    </div>
</sc-activity-list-item>
